module.exports = __webpack_public_path__ + "static/media/icons_Bilan Quadrant sup‚rieur TMO.9d0165a2.svg";